// extracted by css-extract-rspack-plugin
export default {"preview":"vHiVLZ"};